module.exports = fp;


//////////////////
// WEBPACK FOOTER
// external "fp"
// module id = 14
// module chunks = 13